const _isDevEnv = process.env.NODE_ENV === 'development'

export function loggerFactory(warnLevel = 'error', group = '', disabled = false) {
  const _legals = ['log', 'warn', 'error']
  function _(msg, ...arg) {
    let _log
    if (_legals.includes(warnLevel)) {
      _log = console[warnLevel]
    } else {
      _log = console['error']
    }

    return disabled === true ? true : _log(`${group ? ('[' + group + ']' + msg) : msg}`, ...arg)
  }
  return _
}

export function logFactory(group, disabled = false) {
  // return loggerFactory('log', group, !_isDevEnv)
  const dis = disabled === true || !_isDevEnv
  return loggerFactory('log', group, dis)
}
export function warnFactory(group, disabled = false) {
  // const dis = disabled === true || !_isDevEnv
  return loggerFactory('warn', group, disabled)
}
export function errorFactory(group, disabled = false) {
  // const dis = disabled === true || !_isDevEnv

  return loggerFactory('error', group, false)
}

export function log(...msg) {
  const _f = loggerFactory('log')
  return _f(...msg)
}
export function warn(...msg) {
  const _f = loggerFactory('warn')
  return _f(...msg)
}
export function error(...msg) {
  const _f = loggerFactory('error')
  return _f(...msg)
}

export function dlogFactory(group, disabled = false) {
  return loggerFactory('log', group, disabled)
}
export function dwarnFactory(group, disabled = false) {
  return loggerFactory('warn', group, disabled)
}
export function derrorFactory(group, disabled = false) {
  return loggerFactory('error', group, disabled)
}

export function dlog(...msg) {
  const _f = loggerFactory('log', '', !_isDevEnv)
  return _f(...msg)
}
export function dwarn(...msg) {
  const _f = loggerFactory('warn', '', !_isDevEnv)
  return _f(...msg)
}
export function derror(...msg) {
  const _f = loggerFactory('error', '', !_isDevEnv)
  return _f(...msg)
}
